/**
 * The ids of skip links in Privacy Center
 */
export enum SkipLinkIds {
  Navigation = 'navigation',
  Sidebar = 'sidebar',
  Main = 'main',
}
